export default {
    title: '業務窗口'
}
